var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfiledropdownConfiguration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.906,
    height: 17.834,
    viewBox: "0 0 16.906 17.834",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_46945",
    "data-name": "Group 46945",
    transform: "translate(-10.838 -11.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46942",
    "data-name": "Group 46942",
    transform: "translate(15.862 16.487)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54365",
    "data-name": "Path 54365",
    d: "M17.93,21.86a3.43,3.43,0,1,1,3.43-3.43A3.435,3.435,0,0,1,17.93,21.86Zm0-5.488a2.058,2.058,0,1,0,2.058,2.058A2.06,2.06,0,0,0,17.93,16.372Z",
    transform: "translate(-14.5 -15)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_46943",
    "data-name": "Group 46943",
    transform: "translate(10.838 11.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54366",
    "data-name": "Path 54366",
    d: "M20.385,28.835H18.2A1.367,1.367,0,0,1,16.832,27.6l-.174-1.744a6.443,6.443,0,0,1-1.187-.69l-1.6.723a1.365,1.365,0,0,1-1.752-.565l-1.093-1.895a1.369,1.369,0,0,1,.387-1.8l1.412-1.015a5.209,5.209,0,0,1,0-1.391L11.41,18.206a1.369,1.369,0,0,1-.387-1.8l1.093-1.895a1.367,1.367,0,0,1,1.752-.565l1.6.723a6.443,6.443,0,0,1,1.187-.69l.174-1.744A1.367,1.367,0,0,1,18.2,11h2.188a1.367,1.367,0,0,1,1.365,1.236l.174,1.744a6.43,6.43,0,0,1,1.187.69l1.6-.723a1.369,1.369,0,0,1,1.752.565l1.093,1.895a1.369,1.369,0,0,1-.387,1.8l-1.412,1.015a5.209,5.209,0,0,1,0,1.391l1.412,1.015a1.369,1.369,0,0,1,.387,1.8l-1.092,1.893a1.367,1.367,0,0,1-1.752.565l-1.6-.723a6.443,6.443,0,0,1-1.187.69L21.75,27.6a1.367,1.367,0,0,1-1.365,1.235Zm-4.818-5.152a.686.686,0,0,1,.44.161,5.109,5.109,0,0,0,1.527.888.687.687,0,0,1,.447.576l.217,2.155h2.188l.215-2.155a.687.687,0,0,1,.447-.576,5.138,5.138,0,0,0,1.527-.888.685.685,0,0,1,.722-.1l1.981.895,1.093-1.895-1.753-1.259a.69.69,0,0,1-.276-.676,4.345,4.345,0,0,0,0-1.778.689.689,0,0,1,.276-.676L26.372,17.1,25.279,15.2l-1.981.893a.687.687,0,0,1-.723-.1,5.059,5.059,0,0,0-1.527-.888.687.687,0,0,1-.447-.576l-.215-2.159H18.2l-.215,2.155a.687.687,0,0,1-.447.576,5.138,5.138,0,0,0-1.527.888.682.682,0,0,1-.722.1L13.3,15.2,12.211,17.09l1.753,1.259a.69.69,0,0,1,.276.676,4.345,4.345,0,0,0,0,1.778.689.689,0,0,1-.276.676l-1.753,1.259L13.3,24.634l1.981-.893a.717.717,0,0,1,.281-.058Z",
    transform: "translate(-10.838 -11.001)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfiledropdownConfiguration);
export default __webpack_public_path__ + "static/media/profiledropdown-configuration.bd458229cfd7ed1b3a9eb854b5fef304.svg";
export { ForwardRef as ReactComponent };